import { put } from "redux-saga/effects";
import { message } from "antd";

import NotificationApiCaller from "../../config/api/notificationapicaller";

import { NotificationAction } from "../actions";

export default class NotificationMiddleware {
  static *getNotifications({ cb }) {
    try {
      const res = yield NotificationApiCaller.Get(`/notification/getsns`);
      if (res?.status === 200) {
        yield put(NotificationAction.getNotificationsSuccess(res?.data?.data));
      } else {
        yield put(NotificationAction.getNotificationsFailure());
      }
      if (cb) {
        cb(res.data);
      }
    } catch (err) {
      yield put(NotificationAction.getNotificationsFailure());
    }
  }
  static *markAsRead({ cb }) {
    try {
      const res = yield NotificationApiCaller.Put(`/notification/markasread`);
      if (res.status === 200) {
        yield put(NotificationAction.markAsReadSuccess());
        yield put(NotificationAction.getNotifications());
      } else {
        yield put(NotificationAction.markAsReadFailure());
        message.error(res?.data?.message);
      }
      if (cb) {
        cb(res.data.data);
      }
    } catch (err) {
      message.error("Something went wrong.");
      yield put(NotificationAction.markAsReadFailure());
    }
  }
  static *markAsSeen({ cb }) {
    try {
      const res = yield NotificationApiCaller.Put(`/notification/markasseen`);
      if (res.status === 200) {
        yield put(NotificationAction.markAsSeenSuccess());
        yield put(NotificationAction.getNotifications());
      } else {
        yield put(NotificationAction.markAsSeenFailure());
        message.error(res?.data?.message);
      }
      if (cb) {
        cb(res.data.data);
      }
    } catch (err) {
      message.error("Something went wrong.");
      yield put(NotificationAction.markAsSeenFailure());
    }
  }
  static *markAsReadSingle({ payload, cb }) {
    try {
      const res = yield NotificationApiCaller.Put(
        `/notification/markasreadsingle`,
        payload
      );
      if (res.status === 200) {
        yield put(NotificationAction.markAsReadSingleSuccess());
        yield put(NotificationAction.getNotifications());
      } else {
        yield put(NotificationAction.markAsReadSingleFailure());
        message.error(res?.data?.message);
      }
      if (cb) {
        cb(res.data.data);
      }
    } catch (err) {
      message.error("Something went wrong.");
      yield put(NotificationAction.markAsReadSingleFailure());
    }
  }
  static *createSupport({ payload, cb }) {
    try {
      const res = yield NotificationApiCaller.Post(
        `/notification/support`,
        payload
      );
      if (res.status === 200) {
        yield put(NotificationAction.createSupportSuccess());
        message.success(res?.data?.message);
      } else {
        yield put(NotificationAction.createSupportFailure());
        message.error(res?.data?.message);
      }
      if (cb) {
        cb(res.data.data);
      }
    } catch (err) {
      message.error("Something went wrong while sending message.");
      yield put(NotificationAction.createSupportFailure());
    }
  }
}
